import { PUBLIC_BASE_URL, GAME_ID, HEADERS } from '@config/game.js'
import { createFormRequest } from '@helpers/createFormRequest'
import { normalizeSort } from '@composables/useSort.js'
import { queryString } from '@helpers/utils.js'
import { createClient } from '@services'
import qs from 'qs'

const { get, post, put, del, uploadFile } = createClient()

/* API request to get mods for game */
export async function getModsForGameRequest(_, query) {
  const { data } = await get(
    `${PUBLIC_BASE_URL}/games/${GAME_ID}/mods${queryString(query)}`
  )

  const sort = query?._sort ? normalizeSort(query._sort) : ''

  return { ...data, result_sort: sort }
}

/* API request to get mod */
export async function getModRequest(modNameId) {
  const { data } = await get(
    `${PUBLIC_BASE_URL}/games/${GAME_ID}/mods/@${modNameId}`,
    {
      headers: {
        'X-Modio-Platform': HEADERS.platform || 'windows',
      },
    }
  )
  return data
}

/* API request get mod details from cogs API */
export async function getCogsModRequest(gameNameId, modNameId) {
  const { data } = await get(
    `${PUBLIC_BASE_URL}/cogs/games/@${gameNameId}/mods/@${modNameId}`
  )
  return data
}

/* API request to get team members for a mod */
export async function getModTeamMembersRequest(modNameId) {
  const { data } = await get(
    `${PUBLIC_BASE_URL}/games/${GAME_ID}/mods/@${modNameId}/team`
  )
  return data
}

/* API request to add new mod */
export async function addNewModRequest(gameNameId, mod) {
  const formData = createFormRequest(mod)

  const { data } = await post(
    `${PUBLIC_BASE_URL}/games/@${gameNameId}/mods`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
  return data
}

/* API request to update a mod */
export async function updateModRequest(
  gameNameId,
  modNameId,
  update,
  onUploadProgress
) {
  const formData = createFormRequest(update)

  const { data } = await post(
    `${PUBLIC_BASE_URL}/games/@${gameNameId}/mods/@${modNameId}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress,
    }
  )

  return data
}

/* API request to update mod tag */
export async function updateModTagsRequest(gameNameId, modNameId, update) {
  const { data } = await post(
    `${PUBLIC_BASE_URL}/games/@${gameNameId}/mods/@${modNameId}/tags`,
    qs.stringify(update)
  )
  return data
}

/* API request to delete mod tag */
export async function deleteModTagsRequest(gameNameId, modNameId, update) {
  const { data } = await del(
    `${PUBLIC_BASE_URL}/games/@${gameNameId}/mods/@${modNameId}/tags`,
    qs.stringify(update)
  )
  return data
}

/* API request to update mod media */
export async function updateModMediaRequest(
  gameNameId,
  modNameId,
  upload,
  onUploadProgress
) {
  const { data } = await uploadFile(
    `${PUBLIC_BASE_URL}/games/@${gameNameId}/mods/@${modNameId}/media`,
    upload,
    onUploadProgress
  )
  return data
}

/* API request to update mod media ordering */
export async function updateModMediaOrderRequest(
  gameNameId,
  modNameId,
  images
) {
  const { data } = await put(
    `${PUBLIC_BASE_URL}/games/@${gameNameId}/mods/@${modNameId}/media/reorder`,
    qs.stringify({ images })
  )
  return data
}

/* API request to update mod media link  */
export async function updateModMediaLinkRequest(gameNameId, modNameId, update) {
  const { data } = await post(
    `${PUBLIC_BASE_URL}/games/@${gameNameId}/mods/@${modNameId}/media`,
    qs.stringify(update)
  )
  return data
}

/* API request to delete mod media */
export async function deleteModMediaRequest(gameNameId, modNameId, media) {
  const { data } = await del(
    `${PUBLIC_BASE_URL}/games/@${gameNameId}/mods/@${modNameId}/media`,
    qs.stringify(media)
  )
  return data
}

/* API request to delete mod */
export async function deleteModRequest(gameNameId, modNameId, reason) {
  const payload = { reason }
  const { data } = await del(
    `${PUBLIC_BASE_URL}/games/@${gameNameId}/mods/@${modNameId}`,
    qs.stringify(payload)
  )
  return data
}

/* API request to get mod collections */
export async function getModCollectionsRequest(modNameId, query) {
  const { data } = await get(
    `${PUBLIC_BASE_URL}/games/${GAME_ID}/mods/@${modNameId}/collections${queryString(query)}`
  )
  return data
}
